module.exports = __webpack_public_path__ + "static/half-orc_scag-1e9b0778f58a8f78827cfbf44a93b3db.png";